<template>
  <div class="mx-4">
    <v-row>
      <v-col>
        <v-tabs
          v-model="categoria"
          centered
          icons-and-text
        >
          <v-tabs-slider color="secondary" />
          <v-tab
            v-for="i in categorias.length"
            :key="i"
            :href="'#' + categorias[i - 1].id"
            class="mt-3"
          >
            <span class="grey--text text--darken-2">{{
              categorias[i - 1].descricao
            }}</span>
            <v-icon
              :color="categorias[i - 1].id === categoria ? 'secondary' : 'grey'"
            >
              {{ categorias[i - 1].icone }}
            </v-icon>
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row
      v-if="categoria === 'RelatorioPerfilGeral' || categoria === 'RelatorioPerfilUnidade'"
      class="justify-end mt-10"
    >
      <v-spacer />
      <v-col cols="6" md="4">
        <v-select
          v-model="tipo"
          :items="tipos"
          item-text="descricao"
          item-value="id"
          label="Selecione o tipo de monitoramento"
          class="mr-2 ml-4"
          dense
        />
      </v-col>
    </v-row>
    <v-row v-if="categoria === 'RelatorioPerfilParticipacao' || categoria === 'RelatorioPerfilGeral'">
      <v-col cols="12">
        <app-title texto="SELEÇÃO DAS UNIDADES" />
      </v-col>
      <v-col cols="12">
        <selecao-unidade v-model="selecaoUnidade" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <component
          :is="categoria"
          :selecao-unidade="selecaoUnidade"
          :tipo-monitoramento="tipo"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AppTitle from '@/components/core/AppTitle';
import SelecaoUnidade from '@/components/monitoramento/perfil/SelecaoUnidade';
import RelatorioPerfilServidor from '@/components/monitoramento/perfil/relatorio/RelatorioPerfilServidor';
import RelatorioPerfilParticipacao from '@/components/monitoramento/perfil/relatorio/RelatorioPerfilParticipacao';
import RelatorioPerfilGeral from '@/components/monitoramento/perfil/relatorio/RelatorioPerfilGeral';
import RelatorioPerfilUnidade from '@/components/monitoramento/perfil/relatorio/RelatorioPerfilUnidade';

export default {
  name: 'RelatorioGerencialPerfil',

  components: {
    RelatorioPerfilServidor,
    RelatorioPerfilParticipacao,
    RelatorioPerfilGeral,
    RelatorioPerfilUnidade,
    AppTitle,
    SelecaoUnidade,
  },

  data() {
    return {
      categoria: '',
      selecaoUnidade: {
        id: 'unidades',
        tipo: 'unidade',
        habilitado: true,
        unidades: [],
        lista: this.$store.state.unidade.unidades,
        comissao: this.$store.state.auth.comissao,
        macro: false,
        categoria: 'TODOS',
        colunas: 12,
        filhos: [],
      },
      tipo: 'Cadastro',
      tipos: [
        { id: 'Cadastro', descricao: 'Cadastro' },
        { id: 'Formacao', descricao: 'Formação' },
        { id: 'Profissional', descricao: 'Atuação Profissional' },
        { id: 'Interesse', descricao: 'Atividades de Interesse' },
        { id: 'Preferencia', descricao: 'Preferências de Trabalho' },
      ],
    };
  },

  computed: {
    categorias() {
      return [
        {
          id: 'RelatorioPerfilServidor',
          descricao: 'Perfil dos Servidores',
          icone: 'group',
        },
        {
          id: 'RelatorioPerfilParticipacao',
          descricao: 'Participação Geral',
          icone: 'speed',
        },
        {
          id: 'RelatorioPerfilGeral',
          descricao: 'Relatórios Gerenciais',
          icone: 'account_balance',
        },
        {
          id: 'RelatorioPerfilUnidade',
          descricao: 'Relatórios Gerenciais Por Unidade',
          icone: 'account_balance',
        },
      ];
    },
  },
};
</script>
